import React from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { useWishlist } from "@/context/WishlistContext";
import { useCart } from "@/context/CartContext";

export default function ProductCard({ product }) {
  const { has, toggle } = useWishlist();
  const { add } = useCart();
  const wl = has(product.id);

  return (
    <div data-testid={`product-card-${product.slug}`} className="group relative">
      <Link to={`/product/${product.slug}`} className="block">
        <div className="relative aspect-square rounded-2xl bg-secondary/60 overflow-hidden border border-border/50">
          {product.images?.[0] ? (
            <img
              src={product.images[0]}
              alt={product.name}
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.06]"
              loading="lazy"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-muted-foreground text-xs">No image</div>
          )}
          {product.new_arrival && (
            <span className="absolute top-3 left-3 text-[10px] font-mono uppercase tracking-[0.15em] px-2 py-1 rounded-full bg-electric text-white">New</span>
          )}
          {product.best_seller && (
            <span className="absolute top-3 left-3 text-[10px] font-mono uppercase tracking-[0.15em] px-2 py-1 rounded-full bg-foreground text-background">Best</span>
          )}
          <button
            data-testid={`wishlist-btn-${product.slug}`}
            onClick={(e) => { e.preventDefault(); toggle(product); }}
            className={`absolute top-3 right-3 w-9 h-9 rounded-full flex items-center justify-center backdrop-blur-md border border-white/20 transition-all ${wl ? "bg-electric text-white" : "bg-black/40 text-white hover:bg-black/60"}`}
            aria-label="Wishlist"
          >
            <Heart className={`w-4 h-4 ${wl ? "fill-current" : ""}`} />
          </button>
        </div>
      </Link>
      <div className="mt-3 flex items-start justify-between gap-2">
        <div className="min-w-0">
          <div className="text-[10px] font-mono uppercase tracking-[0.2em] text-muted-foreground">{product.subcategory.replace(/-/g, " ")}</div>
          <Link to={`/product/${product.slug}`} className="text-sm font-medium truncate block hover:text-electric transition-colors">{product.name}</Link>
        </div>
        <div className="text-sm font-medium tabular-nums whitespace-nowrap">₹{product.price.toLocaleString()}</div>
      </div>
      <button
        data-testid={`add-cart-${product.slug}`}
        onClick={() => add(product, 1)}
        className="mt-2 w-full h-9 rounded-full text-xs font-medium border border-border hover:border-electric hover:text-electric transition-colors"
      >
        Add to Cart
      </button>
    </div>
  );
}
